import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

// Components
import Layout from '../components/layout'
import PageHeader from '../components/pageHeader'
import PastAuctions from '../components/pastAuctions'
import Seo from '../components/seo'
import SliceList from '../components/sliceList'

export const query = graphql`
  query Page($id: String, $lang: String!) {
    prismicPage(id: { eq: $id }, lang: { eq: $lang }) {
      ...PrismicPageFragment
    }
  }
`

const PageTemplate = ({ data, location }) => {
  const page = data.prismicPage
  const pageData = page.data
  const [showSlices, setShowSlices] = useState(true)
  const [navState, setNavState] = useState('auction')
  const urlParams = new URLSearchParams(location.search)
  let treatyItem = pageData?.page_title?.text || urlParams.get('treatyItem')
  let wantedItem = urlParams.get('wantedItem')
  useEffect(() => {
    let bidJSPage = 'auction'
    if (location?.hash !== '#!/') {
      bidJSPage = location.hash.split('?')[0].replace(/[^a-zA-Z ]/g, '') || 'auction'
    }
    setNavState(bidJSPage)
    setShowSlices(true)
    if (bidJSPage !== 'auction' && bidJSPage !== 'marketplace') {
      setShowSlices(false)
    }
  }, [location])

  return (
    <Layout uid={page.uid} lang={pageData.lang} showSlices={showSlices}>
      {showSlices && <PageHeader treatyItem={treatyItem} pageData={pageData} uid={page.uid} type={page.type} />}
      <div className={`${showSlices !== true ? 'mt-32' : ''}`}>
        <SliceList index={pageData.body} location={location} treatyItem={treatyItem} slices={pageData.body} showSlices={showSlices} navState={navState} wantedItem={wantedItem} uid={page.uid} />
        {navState === 'auction' && page.uid === 'auctions' && <PastAuctions />}
      </div>
    </Layout>
  )
}

export default withPrismicPreview(PageTemplate)

export const Head = ({ data, location }) => {
  const pageData = data.prismicPage.data
  return <Seo pathname={location.pathname} title={pageData.meta_title ? pageData.meta_title : pageData.title} description={pageData.meta_description} image={pageData.carousel[0]?.image.url} />
}
